<template>
  <div class="pa-4">
    <div v-if="loading" class="pa-4 d-flex align-center justify-center">
      <h3 class="font-weight-bold pa-1" small>
        <v-progress-circular :size="16" width="2" indeterminate class="mr-1"></v-progress-circular>
        Fetching History ...
      </h3>
    </div>
    <v-timeline v-if="history.length && !loading">
      <v-timeline-item
        v-for="(item, index) in history"
        :key="`log-${index}`"
        small
        right
        color="#C8C8C880"
        icon-color="grey lighten-2">
        <template slot="opposite">
          <div class="d-flex justify-end">
            <span> <v-icon>mdi-clock-outline</v-icon> {{ item.createDate | formatDate }} </span>
          </div>
        </template>

        <template v-slot:icon>
          <div class="inner-circle"></div>
        </template>
        <v-row class="historyCard">
          <v-col cols="12" class="pa-0">
            <div class="d-flex">
              <UserAvatar class="mb-2" :hideRoles="true" :user="item.createdBy"></UserAvatar>
            </div>
            <div v-for="(row, i) in item.body" :key="i" class="d-flex align-center">
              <template v-if="row.propName == 'Status'">
                <v-row class="mb-1">
                  <v-col class="d-flex align-center justify-end pa-0" cols="1">
                    <v-icon class="mt-2">mdi-arrow-u-right-bottom</v-icon>
                  </v-col>
                  <v-col cols="11" class="px-0">
                    <div class="d-flex mb-1 align-center">
                      <img class="me-2" width="12px" height="12px" src="@Assets/svgs/history.svg" />
                      <b class="me-2" style="color: var(--v-grey-500-base)">{{ row.propName }}: </b>
                      {{ row.oldValue ? row.oldValue.name : 'None' }}
                    </div>
                    <div class="d-flex align-center">
                      <img class="me-2" width="12px" height="12px" src="@Assets/svgs/history.svg" />
                      <b class="me-2" style="color: var(--v-grey-500-base)">{{ row.propName }}: </b>
                      {{ row.newValue ? row.newValue.name : 'None' }}
                    </div>
                  </v-col>
                </v-row>
              </template>
              <template v-else-if="row.propName == 'Parent'">
                <v-row class="mb-1">
                  <v-col class="d-flex align-center justify-end pa-0" cols="1">
                    <v-icon class="mt-2">mdi-arrow-u-right-bottom</v-icon>
                  </v-col>
                  <v-col cols="11" class="px-0">
                    <div class="d-flex mb-1 align-center">
                      <img class="me-2" width="12px" height="12px" src="@Assets/svgs/history.svg" />
                      <b class="me-2" style="color: var(--v-grey-500-base)">{{ row.propName }}: </b>
                      {{ row.oldValue ? row.oldValue.friendlyId : 'None' }}
                    </div>
                    <div class="d-flex align-center">
                      <img class="me-2" width="12px" height="12px" src="@Assets/svgs/history.svg" />
                      <b class="me-2" style="color: var(--v-grey-500-base)">{{ row.propName }}: </b>
                      {{ row.newValue ? row.newValue.friendlyId : 'None' }}
                    </div>
                  </v-col>
                </v-row>
              </template>
              <!-- <template v-else-if="row.propName == 'Type'">
                <v-row class="mb-1">
                  <v-col class="d-flex align-center justify-end pa-0" cols="1">
                    <v-icon class="mt-2">mdi-arrow-u-right-bottom</v-icon>
                  </v-col>
                  <v-col cols="11" class="px-0">
                    <div class="d-flex mb-1 align-center">
                      <img class="me-2" width="12px" height="12px" src="@Assets/svgs/history.svg" />
                      <b class="me-2" style="color: var(--v-grey-500-base)">{{ row.propName }}: </b>
                      {{ row.oldValue.name ? row.oldValue.name : row.oldValue }}
                    </div>
                    <div class="d-flex align-center">
                      <img class="me-2" width="12px" height="12px" src="@Assets/svgs/history.svg" />
                      <b class="me-2" style="color: var(--v-grey-500-base)">{{ row.propName }}: </b>
                      {{ row.newValue.name ? row.newValue.name : row.newValue }}
                    </div>
                  </v-col>
                </v-row>
              </template> -->

              <template
                v-else-if="
                  row.propName == 'AssignedTo' ||
                  row.propName == 'ReportedBy' ||
                  row.propName == 'ApprovedBy'
                ">
                <v-row class="mb-1">
                  <v-col class="d-flex align-center justify-end pa-0" cols="1">
                    <v-icon class="mt-2">mdi-arrow-u-right-bottom</v-icon>
                  </v-col>
                  <v-col cols="11" class="px-0">
                    <div class="d-flex mb-1 align-center">
                      <img class="me-2" width="12px" height="12px" src="@Assets/svgs/history.svg" />
                      <b class="me-2" style="color: var(--v-grey-500-base)">{{ row.propName }}: </b>
                      {{ row.oldValue ? row.oldValue.email : 'None' }}
                    </div>
                    <div class="d-flex align-center">
                      <img class="me-2" width="12px" height="12px" src="@Assets/svgs/history.svg" />
                      <b class="me-2" style="color: var(--v-grey-500-base)">{{ row.propName }}: </b>
                      {{ row.newValue ? row.newValue.email : 'None' }}
                    </div>
                  </v-col>
                </v-row>
              </template>

              <template v-else-if="row.propName.includes('Date')">
                <v-row class="mb-1">
                  <v-col class="d-flex align-center justify-end pa-0" cols="1">
                    <v-icon class="mt-2">mdi-arrow-u-right-bottom</v-icon>
                  </v-col>
                  <v-col cols="11" class="px-0">
                    <div class="d-flex mb-1 align-center">
                      <img class="me-2" width="12px" height="12px" src="@Assets/svgs/history.svg" />
                      <b class="me-2" style="color: var(--v-grey-500-base)">{{ row.propName }}: </b>
                      {{ row.oldValue ? $formatDate(row.oldValue) : 'None' }}
                    </div>
                    <div class="d-flex align-center">
                      <img class="me-2" width="12px" height="12px" src="@Assets/svgs/history.svg" />
                      <b class="me-2" style="color: var(--v-grey-500-base)">{{ row.propName }}: </b>
                      {{ row.newValue ? $formatDate(row.newValue) : 'None' }}
                    </div>
                  </v-col>
                </v-row>

                <!-- <b style="color: var(--v-grey-500-base)">{{ row.propName }}: </b>
                {{ row.oldValue ? $formatDate(row.oldValue) : 'None' }}
                <i class="fa-solid fa-right-long mx-5"></i>
                {{ row.newValue ? $formatDate(row.newValue) : 'None' }} -->
              </template>

              <template v-else-if="row.propName == 'Project'">
                <v-row class="mb-1">
                  <v-col class="d-flex align-center justify-end pa-0" cols="1">
                    <v-icon class="mt-2">mdi-arrow-u-right-bottom</v-icon>
                  </v-col>
                  <v-col cols="11" class="px-0">
                    <div class="d-flex mb-1 align-center">
                      <img class="me-2" width="12px" height="12px" src="@Assets/svgs/history.svg" />
                      <b class="me-2" style="color: var(--v-grey-500-base)">{{ row.propName }}: </b>
                      {{ row.oldValue ? row.oldValue.description : 'None' }}
                    </div>
                    <div class="d-flex align-center">
                      <img class="me-2" width="12px" height="12px" src="@Assets/svgs/history.svg" />
                      <b class="me-2" style="color: var(--v-grey-500-base)">{{ row.propName }}: </b>
                      {{ row.newValue ? row.newValue.description : 'None' }}
                    </div>
                  </v-col>
                </v-row>
              </template>
              <template v-else-if="row.propName == 'CustomFields'">
                <img class="me-2" width="12px" height="12px" src="@Assets/svgs/history.svg" />
                <v-row no-gutters>
                  <v-col> <b>Custom Fields </b></v-col>
                </v-row>
                <v-row no-gutters>
                  <v-col cols="5">
                    <template v-if="!row.oldValue">
                      <div>
                        <span> None</span>
                      </div>
                    </template>

                    <template v-if="row.oldValue">
                      <div v-for="(item, i) in row.oldValue" :key="i" x-small class="mr-2">
                        <span v-if="item.name">{{ item.name }}</span>
                      </div>
                    </template>
                  </v-col>
                  <v-col cols="2">
                    <i class="fa-solid fa-right-long mx-5"></i>
                  </v-col>
                  <v-col cols="5">
                    <template v-if="!row.newValue">
                      <div>
                        <span> None</span>
                      </div>
                    </template>

                    <template v-if="row.newValue">
                      <div v-for="(item, i) in row.newValue" :key="i">
                        <span v-if="item.name">{{ item.name }}</span>
                      </div>
                    </template>
                  </v-col>
                </v-row>
              </template>

              <template v-else-if="row.propName == 'ForgeTags'">
                <v-row class="mb-1">
                  <v-col class="d-flex align-center justify-end pa-0" cols="1">
                    <v-icon class="mt-2">mdi-arrow-u-right-bottom</v-icon>
                  </v-col>
                  <v-col cols="11" class="px-0">
                    <div class="d-flex mb-1 align-center">
                      <img class="me-2" width="12px" height="12px" src="@Assets/svgs/history.svg" />
                      <b class="me-2" style="color: var(--v-grey-500-base)">Forge Tags : </b>
                      <template v-if="!row.oldValue">
                        <div>
                          <span> None</span>
                        </div>
                      </template>

                      <template v-if="row.oldValue">
                        <div>
                          <v-chip v-for="(item, i) in row.oldValue" :key="i" x-small class="mr-2">
                            <span v-if="item.name">{{ item.name }}</span>
                          </v-chip>
                        </div>
                      </template>
                    </div>
                    <div class="d-flex align-center">
                      <img class="me-2" width="12px" height="12px" src="@Assets/svgs/history.svg" />
                      <b class="me-2" style="color: var(--v-grey-500-base)">{{ row.propName }}: </b>
                      <template v-if="!row.newValue">
                        <div>
                          <span> None</span>
                        </div>
                      </template>

                      <template v-if="row.newValue">
                        <div>
                          <v-chip v-for="(item, i) in row.newValue" :key="i" x-small class="mr-2">
                            <span v-if="item.name">{{ item.name }}</span>
                          </v-chip>
                        </div>
                      </template>
                    </div>
                  </v-col>
                </v-row>
              </template>

              <template v-else-if="row.propName == 'Color'">
                <v-row class="mb-1">
                  <v-col class="d-flex align-center justify-end pa-0" cols="1">
                    <v-icon class="mt-2">mdi-arrow-u-right-bottom</v-icon>
                  </v-col>
                  <v-col cols="11" class="px-0">
                    <div class="d-flex mb-1 align-center">
                      <img class="me-2" width="12px" height="12px" src="@Assets/svgs/history.svg" />
                      <b class="me-2" style="color: var(--v-grey-500-base)">{{ row.propName }}: </b>
                      <v-icon v-if="row.oldValue" :color="row.oldValue" class="mr-2"
                        >mdi-circle</v-icon
                      >
                      <div v-else class="color-box">None</div>
                    </div>
                    <div class="d-flex align-center">
                      <img class="me-2" width="12px" height="12px" src="@Assets/svgs/history.svg" />
                      <b class="me-2" style="color: var(--v-grey-500-base)">{{ row.propName }}: </b>
                      <v-icon v-if="row.newValue" :color="row.newValue" class="mr-2"
                        >mdi-circle</v-icon
                      >
                      <div v-else class="color-box">None</div>
                    </div>
                  </v-col>
                </v-row>
              </template>

              <template v-else-if="row.propName == 'Participants'">
                <v-row class="mb-1">
                  <v-col cols="12" class="px-0">
                    <template v-if="row.oldValue && !row.newValue">
                      <div class="d-flex mb-1 align-center">
                        <img
                          class="me-2"
                          width="12px"
                          height="12px"
                          src="@Assets/svgs/history.svg" />
                        <v-icon class="me-2" color="error">mdi-minus</v-icon>
                        <b class="me-2" style="color: var(--v-grey-500-base)"
                          >{{ row.propName }}:
                        </b>
                        {{ row.oldValue ? row.oldValue : 'None' }}
                      </div>
                    </template>
                    <template v-if="!row.oldValue && row.newValue">
                      <div class="d-flex align-center">
                        <img
                          class="me-2"
                          width="12px"
                          height="12px"
                          src="@Assets/svgs/history.svg" />
                        <v-icon class="me-2" color="success">mdi-plus</v-icon>
                        <b class="me-2" style="color: var(--v-grey-500-base)"
                          >{{ row.propName }}:
                        </b>
                        {{ row.newValue ? row.newValue : 'None' }}
                      </div>
                    </template>
                    <template v-if="row.oldValue && row.newValue">
                      <div class="d-flex mb-1 align-center">
                        <img
                          class="me-2"
                          width="12px"
                          height="12px"
                          src="@Assets/svgs/history.svg" />
                        <v-icon class="me-2">mdi-arrow-u-right-bottom</v-icon>
                        <b class="me-2" style="color: var(--v-grey-500-base)"
                          >{{ row.propName }}:
                        </b>
                        {{ row.oldValue ? row.oldValue : 'None' }}
                      </div>
                      <div class="d-flex align-center">
                        <img
                          class="me-2"
                          width="12px"
                          height="12px"
                          src="@Assets/svgs/history.svg" />
                        <v-icon class="me-2">mdi-arrow-u-right-bottom</v-icon>
                        <b class="me-2" style="color: var(--v-grey-500-base)"
                          >{{ row.propName }}:
                        </b>
                        {{ row.newValue ? row.newValue : 'None' }}
                      </div>
                    </template>
                  </v-col>
                </v-row>
              </template>

              <template v-else>
                <v-row class="mb-1">
                  <v-col class="d-flex align-center justify-end pa-0" cols="1">
                    <v-icon class="mt-2">mdi-arrow-u-right-bottom</v-icon>
                  </v-col>
                  <v-col cols="11" class="px-0">
                    <div class="d-flex mb-1 align-center">
                      <img class="me-2" width="12px" height="12px" src="@Assets/svgs/history.svg" />
                      <b class="me-2" style="color: var(--v-grey-500-base)">{{ row.propName }}: </b>
                      {{ row.oldValue ? row.oldValue : 'None' }}
                    </div>
                    <div class="d-flex align-center">
                      <img class="me-2" width="12px" height="12px" src="@Assets/svgs/history.svg" />
                      <b class="me-2" style="color: var(--v-grey-500-base)">{{ row.propName }}: </b>
                      {{ row.newValue ? row.newValue : 'None' }}
                    </div>
                  </v-col>
                </v-row>
              </template>
            </div>
          </v-col>
          <!-- <v-col class="text-right pt-5 pb-0" cols="2">
            <span class="grey--text subtitle-2">{{ item.createDate | formatDate }} </span>
          </v-col> -->
        </v-row>
      </v-timeline-item>
    </v-timeline>
    <div
      v-if="!history.length && !loading"
      class="d-flex flex-column align-center justify-center"
      style="height: calc(100% - 24px)">
      <v-icon x-large class="mb-4">fa-history </v-icon>
      <div class="mb-2">No History Found</div>
    </div>
  </div>
</template>

<script>
  import UserAvatar from '@Share/components/UserAvatar.vue';
  import { mapGetters } from 'vuex';
  import { $formatDate } from '@Utils';
  export default {
    components: {
      UserAvatar,
    },
    data() {
      return {
        taskId: null,
      };
    },
    computed: {
      ...mapGetters('TASK_HISTORY', {
        loading: 'GET_LOADING',
        entries: 'GET_ENTRIES',
        total: 'GET_TOTAL',
        options: 'GET_OPTIONS',
      }),
      history() {
        if (this.entries.length > 0) {
          return this.entries.map((e) => this.mapEntries(e)).filter(entry => entry !== null);
        } else {
          return [];
        }
      },
      currentTaskType() {
        return this.$store.getters['TASK_MANAGER/GET_CURRENT_TASK_TYPE'];
      },
      customFields() {
        return this.currentTaskType.sections.flatMap((t) => t.fields);
      },
      fieldsOptions() {
        return this.customFields.flatMap((f) => f.options);
      },
    },
    mounted() {},
    methods: {
      $formatDate,
      open(id) {
        this.taskId = id;
        this.$store.dispatch('TASK_HISTORY/GET', this.taskId);
      },
      isEmpty(val) {
        return val == 'None' || val == 'none' || !val;
      },
      isJson(val) {
        try {
          JSON.parse(val);
          return true;
        } catch (e) {
          return false;
        }
      },
      isGuid(val) {
        if (!val || typeof val !== 'string') return false;
        const guidRegex = /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i;
        return guidRegex.test(val);
      },
      mapEntries(e) {
        let entry = structuredClone(e);
        let shouldSkipEntry = false;

        if (entry.body.length === 0) {
          return null;
        }

        entry.body.forEach((body) => {
          switch (body.propName) {
            case 'ReportedBy':
            case 'ApprovedBy':
            case 'Project':
            case 'Status':
            case 'Parent':
              if (!this.isEmpty(body.oldValue) && this.isJson(body.oldValue))
                body.oldValue = JSON.parse(body.oldValue);
              if (!this.isEmpty(body.newValue) && this.isJson(body.newValue))
                body.newValue = JSON.parse(body.newValue);
              break;
            case 'ForgeTags':
            case 'CustomFields':
              if (!this.isEmpty(body.oldValue)) body.oldValue = JSON.parse(body.oldValue);
              if (body.oldValue)
                for (let i = 0; i < body.oldValue.length; i++) {
                  body.oldValue[i] = JSON.parse(body.oldValue[i]);
                }

              if (!this.isEmpty(body.newValue)) body.newValue = JSON.parse(body.newValue);
              if (body.newValue)
                for (let i = 0; i < body.newValue.length; i++) {
                  body.newValue[i] = JSON.parse(body.newValue[i]);
                }

              break;

            default:
              {
                const findOptionByGuid = (guid) => {
                  for (const field of this.customFields) {
                    if (field.options) {
                      const option = field.options.find((o) => o.id === guid);
                      if (option) {
                        return { option, field };
                      }
                    }
                  }
                  return null;
                };

                if (this.isGuid(body.oldValue)) {
                  const result = findOptionByGuid(body.oldValue);
                  if (result) {
                    body.oldValue = result.option.value;
                    body.propName = result.field.label;
                  } else {
                    shouldSkipEntry = true;
                  }
                }

                if (this.isGuid(body.newValue)) {
                  const result = findOptionByGuid(body.newValue);
                  if (result) {
                    body.newValue = result.option.value;
                    body.propName = result.field.label;
                  } else {
                    shouldSkipEntry = true;
                  }
                }
              }
              break;
          }
        });
        
        if (shouldSkipEntry) {
          return null;
        }
        
        return entry;
      },
    },
  };
</script>

<style lang="scss">
  .historyCard {
    padding: 10px 15px 10px 15px;
    gap: 7px;
    border-radius: 7px;
    border: 1px solid var(--v-light-grey-base) !important;
    margin-bottom: 10px;
  }
  .inner-circle {
    width: 10px;
    height: 10px;
    background-color: #aeaeae;
    border-radius: 50%;
  }
  .v-timeline-item__opposite {
    flex: 0 1 auto;
  }
  .v-timeline:not(.v-timeline--dense):not(.v-timeline--reverse)
    .v-timeline-item:nth-child(odd):not(.v-timeline-item--before),
  .v-timeline:not(.v-timeline--dense):not(.v-timeline--reverse) .v-timeline-item--after {
    justify-content: flex-end;
  }
  .v-timeline:not(.v-timeline--dense):not(.v-timeline--reverse) {
    &:before {
      left: 138px !important;
    }
  }
  .v-timeline:not(.v-timeline--dense):not(.v-timeline--reverse)
    .v-timeline-item:nth-child(odd):not(.v-timeline-item--before)
    .v-timeline-item__body,
  .v-timeline:not(.v-timeline--dense):not(.v-timeline--reverse)
    .v-timeline-item--after
    .v-timeline-item__body {
    max-width: calc(78% - 48px);
  }
  .v-timeline-item__divider {
    min-width: 60px;
  }
  .theme--light.v-timeline .v-timeline-item__dot {
    background: #ededed;
  }
  .v-timeline-item__dot {
    box-shadow: none;
  }
</style>
